import {
  LucideActivity,
  LucideBadgeCheck,
  LucideBook,
  LucideBox,
  LucideBriefcase,
  LucideCalendar,
  LucideCalendarRange,
  LucideChevronDown,
  LucideChevronRight,
  LucideCircleCheckBig,
  LucideClock,
  LucideCloudRain,
  LucideComponent,
  LucideDatabase,
  LucideDownload,
  LucideDroplet,
  LucideExternalLink,
  LucideFile,
  LucideFlaskConical,
  LucideFolder,
  LucideFolderOpen,
  LucideGauge,
  LucideGitMerge,
  LucideGraduationCap,
  LucideHandHeart,
  LucideHome,
  LucideIdCard,
  LucideImage,
  LucideInfo,
  LucideKeyRound,
  LucideLayoutDashboard,
  LucideLeaf,
  LucideLink,
  LucideList,
  LucideListChecks,
  LucideLogOut,
  LucideLayers,
  LucideMail,
  LucideMap,
  LucideMapPin,
  LucideMenu,
  LucideMegaphone,
  LucideMicroscope,
  LucideMoon,
  LucideNewspaper,
  LucidePanelLeftClose,
  LucidePanelLeftOpen,
  LucidePaperclip,
  LucidePen,
  LucidePhone,
  LucideRadar,
  LucideRadio,
  LucideRoute,
  LucideRuler,
  LucideSearch,
  LucideSend,
  LucideSettings,
  LucideShield,
  LucideShoppingCart,
  LucideSprout,
  LucideSplit,
  LucideSun,
  LucideTable2,
  LucideToggleLeft,
  LucideUpload,
  LucideUser,
  LucideUsers,
  LucideWaves,
  LucideX,
  type LucideIconData,
} from '@lucide/angular';

/**
 * AppIconRegistry — registro central de iconos de la aplicación.
 *
 * Las claves son los nombres de icono que los repositorios de menú declaran en
 * `MenuEntity.icon` (p. ej. 'layers', 'users'). El plano de presentación resuelve
 * los iconos EXCLUSIVAMENTE a través de este registro + LucideDynamicIcon: ningún
 * template decide qué icono dibujar mediante switch/es.
 */
export class AppIconRegistry {
  static readonly ICONS: Record<string, LucideIconData> = {
    'activity': LucideActivity.icon,
    'badge-check': LucideBadgeCheck.icon,
    'book': LucideBook.icon,
    'box': LucideBox.icon,
    'briefcase': LucideBriefcase.icon,
    'calendar': LucideCalendar.icon,
    'calendar-range': LucideCalendarRange.icon,
    'chevron-down': LucideChevronDown.icon,
    'chevron-right': LucideChevronRight.icon,
    'circle-check-big': LucideCircleCheckBig.icon,
    'clock': LucideClock.icon,
    'cloud-rain': LucideCloudRain.icon,
    'component': LucideComponent.icon,
    'database': LucideDatabase.icon,
    'download': LucideDownload.icon,
    'droplet': LucideDroplet.icon,
    'external-link': LucideExternalLink.icon,
    'file': LucideFile.icon,
    'flask-conical': LucideFlaskConical.icon,
    'folder': LucideFolder.icon,
    'folder-open': LucideFolderOpen.icon,
    'gauge': LucideGauge.icon,
    'git-merge': LucideGitMerge.icon,
    'graduation-cap': LucideGraduationCap.icon,
    'hand-heart': LucideHandHeart.icon,
    'home': LucideHome.icon,
    'id-card': LucideIdCard.icon,
    'image': LucideImage.icon,
    'info': LucideInfo.icon,
    'key-round': LucideKeyRound.icon,
    'layout-dashboard': LucideLayoutDashboard.icon,
    'leaf': LucideLeaf.icon,
    'link': LucideLink.icon,
    'list': LucideList.icon,
    'list-checks': LucideListChecks.icon,
    'log-out': LucideLogOut.icon,
    'layers': LucideLayers.icon,
    'mail': LucideMail.icon,
    'map': LucideMap.icon,
    'map-pin': LucideMapPin.icon,
    'menu': LucideMenu.icon,
    'megaphone': LucideMegaphone.icon,
    'microscope': LucideMicroscope.icon,
    'moon': LucideMoon.icon,
    'newspaper': LucideNewspaper.icon,
    'panel-left-close': LucidePanelLeftClose.icon,
    'panel-left-open': LucidePanelLeftOpen.icon,
    'paperclip': LucidePaperclip.icon,
    'pen': LucidePen.icon,
    'phone': LucidePhone.icon,
    'radar': LucideRadar.icon,
    'radio': LucideRadio.icon,
    'route': LucideRoute.icon,
    'ruler': LucideRuler.icon,
    'search': LucideSearch.icon,
    'send': LucideSend.icon,
    'settings': LucideSettings.icon,
    'shield': LucideShield.icon,
    'shopping-cart': LucideShoppingCart.icon,
    'sprout': LucideSprout.icon,
    'split': LucideSplit.icon,
    'sun': LucideSun.icon,
    'table-2': LucideTable2.icon,
    'toggle': LucideToggleLeft.icon,
    'upload': LucideUpload.icon,
    'user': LucideUser.icon,
    'users': LucideUsers.icon,
    'waves': LucideWaves.icon,
    'x': LucideX.icon,
  };
}
